import { ace } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';

export const getAxoVersion =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({ applicationID }: { applicationID: string }): Promise<ace.AxoVersion> =>
    send({
      baseURL,
      token,
      path: `/ace/axo-versions/${encodeURIComponent(applicationID)}`,
      method: 'GET',
    });

export const createAxoVersion =
  ({ token, url: { service: baseURL } }: IAPI) =>
  (body: ace.CreateAxoVersionPayload): Promise<ace.AxoVersion> =>
    send({
      baseURL,
      token,
      path: '/ace/axo-versions',
      method: 'POST',
      body,
    });
